import React from 'react';

type Props = {
  className: string;
  color: string;
  icon: React.ReactElement;
  iconColor: string;
  title: string;
  titleColor?: string;
  description: string;
  descriptionColor?: string;
  todayText?: string; // Translation for "Today"
  todayValue?: string; // Value for "Today"
  onClick?: () => void; // Optional onClick handler
};

const StatisticsWidget5: React.FC<Props> = ({
  className,
  color,
  icon,
  iconColor,
  title,
  titleColor = 'dark',
  description,
  descriptionColor = 'muted',
  todayText,
  todayValue,
  onClick,
}) => {
  return (
    <a
      href='#'
      className={`card bg-${color} hoverable ${className}`}
      onClick={(e) => {
        e.preventDefault();
        onClick && onClick();
      }}
    >
      <div className='card-body'>
        <div className={`icon-wrapper text-${iconColor} svg-icon-3x ms-n1`}>{icon}</div>
        <div className={`text-${titleColor} fw-bold fs-2 mb-2 mt-5`}>{title}</div>
        <div className={`fw-semibold text-${descriptionColor}`}>{description}</div>
        {todayText && todayValue && (
          <div className='mt-3'>
            <span className='text-white fs-6'>{todayText}</span>:&nbsp;
            <span className='text-black fw-bold fs-5'>{todayValue}</span>
          </div>
        )}
      </div>
    </a>
  );
};

export { StatisticsWidget5 };
